export default "__VITE_ASSET__cb3088e0__"